import { HttpClient } from "@angular/common/http";
import { Component, Inject, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AuthService } from "../../core/services/auth/auth.service";
import { UserSiteLinksDialogComponent } from "../user-site-links-dialog/user-site-links-dialog.component";
import { GetUserSiteLinksInfo } from "../../core/data/models/get-user-site-links-info";
import {
  GetUserWithSitesLinksInfo,
  UserSite,
} from "../../core/data/models/get-user-with-sites-links-info";
import { SiteInfo } from "../../core/data/models/get-site-info";
import { CompanyInfo } from "../../core/data/models/get-company-info";

@Component({
  selector: "app-user-detail-dialog",
  templateUrl: "./user-detail-dialog.component.html",
  styleUrls: ["./user-detail-dialog.component.scss"],
})
export class UserDetailDialogComponent implements OnInit {
  // 施設情報
  siteData: SiteInfo[];
  // 会社情報
  companyData: CompanyInfo[] = new Array();
  siteInfoList: UserSite[] = new Array();

  @Input() public userSiteLinksInfo: GetUserSiteLinksInfo[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public user: GetUserWithSitesLinksInfo,

    public confirmDialog: MatDialog,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<UserDetailDialogComponent>,
    private router: Router,
    public auth: AuthService
  ) {}

  ngOnInit() {}

  onClickSelectSite() {
    const dialogRef = this.dialog.open(UserSiteLinksDialogComponent, {
      width: "1000px",
      data: this.user.sites,
    });
  }
}
